import { UiComponent } from '../../interfaces/pagebuilder';
import { useSelector } from '../../reduxToolkit/typedRedux';

const usePBVisibility = () => {
  const registrationFields = useSelector(({ common }) => common.eventRegistration?.registrationFields);
  const eventRegistration = useSelector(({ common }) => common.eventRegistration);
  const event = useSelector(({ common }) => common.event);
  const user = useSelector(({ common }) => common.user);

  /**
   * @name showComponent
   * @param component
   * @description checks depending on multiple conditions whether to show the component or hide it
   * @returns boolean value, if true, the component is visibile, otherwise it's hidden
   */
  const showComponent = (component: UiComponent) => {
    // check if the component is supposed to be visible or not
    if (!component.isVisible) return false;

    // check if the component is a subcomponent of a column component
    if (!!component.columnComponent) return false;

    // show speeddating components only if the matching module is active
    if (component.componentType === 'speeddating' && !event?.modules.matching.active) return false;

    /**
     * in case the component is restricted depending on regsitration fields,
     * check if the required fields values match the user's information
     */
    const isValuesCorresponding = component.registrationFields?.every((rf) => rf.value === registrationFields?.find((f) => f.field._id === rf.field)?.value);
    const registrationRestricted = !component.isRestricted || isValuesCorresponding;
    if (!registrationRestricted) return false;

    /**
     * in case the component's visibility depends on the user's registration approval,
     * check if the current user's registration status matches the approval setting for component's visibility
     */
    const userApproval =
      event?.modules?.guestmanagement?.settings?.autoApproveUser ||
      component.userApproval.length === 0 ||
      component.userApproval.includes('all') ||
      (component.userApproval.includes('accepted') && eventRegistration?.status === 'accepted') ||
      (component.userApproval.includes('rejected') && eventRegistration?.status === 'rejected') ||
      (component.userApproval.includes('pending') && eventRegistration?.status === 'loading');

    /**
     * Defines the type of users allowed to see the component using the previously
     * mentioned condition, userApproval
     */
    const accessType =
      component.accessType === 'anyone' || (component.accessType === 'user' && !!user && userApproval) || (component.accessType === 'visitor' && !user);

    return accessType;
  };
  return {
    showComponent,
  };
};
export default usePBVisibility;
